/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerListDocumentTypesQueryResponse } from "../../models/documentUseCasesController/DocumentUseCasesControllerListDocumentTypes";

function getDocumentUseCasesControllerListDocumentTypesUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/classifications/document-types` as const }  
  return res
}

/**
 * @description The vocabulary the classifier answers from; the console's override picker filters these.
 * @summary List every active document type in the taxonomy
 * {@link /api/v1/documents/classifications/document-types}
 */
export async function documentUseCasesControllerListDocumentTypes(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerListDocumentTypesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDocumentUseCasesControllerListDocumentTypesUrl().url.toString(), ... requestConfig })  
  return res.data
}